import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import EvaluatorPaymentService from '../../../Services/EvaluatorPaymentService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import AssignmentPaymentsAdminSearchParams from './AssignmentPaymentsAdminSearchParams';
import EvaluatorPaymentAdminItem from '../../../Domain/EvaluatorPaymentAdminItem';
import EvaluatorPaymentItem from '../../../Domain/EvaluatorPaymentItem';
import VoidWindowDescription from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/VoidWindowDescription';
import VoidAndReissueWindowDescription from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/VoidAndReissueWindowDescription';
import VoidAndSupressWindowDescription from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/VoidAndSupressWindowDescription';
import ApproveWindowDescription from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/ApproveWindowDescription';
import EvaluatorPaymentActionParamsItem from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EvaluatorPaymentActionParamsItem';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditEvaluatorPaymentWindowDescription from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EditEvaluatorPaymentWindowDescription';
import PaymentRequestStatusChangeWindowDescription from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/PaymentRequestStatusChangeWindowDescription';

export default class AssignmentPaymentsAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new AssignmentPaymentsAdminSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
      popup: null,
      selected: -1,
      selectedInvoiceEvaluator: null,
      itemList: [],
    };

    this.startSearch = this.startSearch.bind(this);
    this.renderActionButtons = this.renderActionButtons.bind(this);
    EvaluatorPaymentItem.actionFunction = this.clickOnAction.bind(this);
    EvaluatorPaymentItem.editFunction = this.clickOnEdit.bind(this);
    EvaluatorPaymentAdminItem.clickOnSelect = this.clickOnSelect.bind(this);
    EvaluatorPaymentItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  statusChangeFunction(item) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedInvoiceEvaluator: item,
    });
  }

  clickOnEdit(invoiceEvaluator) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: invoiceEvaluator.IeId,
      selectedInvoiceEvaluator: invoiceEvaluator,
    });
  }

  editPanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  savePanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.EditItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={this.state.selectedInvoiceEvaluator}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditEvaluatorPaymentWindowDescription}
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.StatusUpdate) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={{
            ...this.state.selectedInvoiceEvaluator,
            Id: this.state.selectedInvoiceEvaluator.IeId,
            Comment: '',
          }}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={PaymentRequestStatusChangeWindowDescription}
        />
      );
    }
  }

  clickOnSelect(item) {
    item.Selected = !item.Selected;
    this.setState({ itemList: [...this.state.itemList] });
  }

  clickOnAction(ieIds, actionType) {
    let windowDescription = null;
    switch (actionType) {
      case 'Void':
        windowDescription = VoidWindowDescription;
        break;
      case 'VoidAndReissue':
        windowDescription = VoidAndReissueWindowDescription;
        break;
      case 'VoidAndSupress':
        windowDescription = VoidAndSupressWindowDescription;
        break;
      default:
        windowDescription = ApproveWindowDescription;
    }

    const paramsData = new EvaluatorPaymentActionParamsItem(
      ieIds,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem
    );

    this.setState({
      popup: (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={paramsData}
          clickOnCancel={() => this.setState({ popup: null })}
          clickOnSave={() => this.setState({ popup: null })}
          windowDescription={windowDescription}
        />
      ),
    });
  }

  renderActionButtons() {
    const disabled = !this.state.itemList.find((il) => il.Selected);
    return (
      <FigmaButtonRow
        buttons={[
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'Approve'
              ),
            tooltip: 'Approve',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-regular fa-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'Void'
              ),
            tooltip: 'Void',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-solid fa-rotate-right',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'VoidAndReissue'
              ),
            tooltip: 'Void & Reissue',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-solid fa-trash',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'VoidAndSupress'
              ),
            tooltip: 'Void & Supress',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
        ]}
      />
    );
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={EvaluatorPaymentAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorPaymentService.GetEvaluatorPayments}
          convertDBItemsFunction={EvaluatorPaymentService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='AsEvname'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={AssignmentPaymentsAdminSearchParams}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Clients, Evaluators, Projects, Apollo Job IDs or Pay IDs...'
        />
      </div>
    );
  }
}
